import {UserRepository} from '@web-libs/features/users/domain/user.repository';
import {HttpClient} from '@web-libs/core/http';
import {Page} from '@web-libs/core/pagination/api/pagination.functions';
import {parseUserDTO, UserDTO} from '@web-libs/features/users/api/user-dto.types';
import {TrmzFileDTOConverter} from '@web-libs/features/files/trmz-file/api/trmz-file-dto-converter';

type LoadUsersQueryParams = {
    size: number,
    page: number
    filterValue?: string
    filterFields?: string[]
    sort?: string
}

export const createRemoteUserRepository = (http: HttpClient,
                                           trmzFileConverter: TrmzFileDTOConverter): UserRepository => {

    const getQueryParams = (pageSize: number,
                            pageNumber: number,
                            searchTerm?: string,) => {
        const params: LoadUsersQueryParams = {
            size: pageSize,
            page: pageNumber,
            sort: 'lastName,asc'
        };
        if (searchTerm) {
            params.filterFields = ['FIRST_NAME', 'LAST_NAME', 'USERNAME'];
            params.filterValue = '%' + searchTerm + '%';
        }
        return params;
    };

    const loadUsers = async (pageSize: number,
                             pageNumber: number) => {
        const userDTOPage = await http.get<Page<UserDTO>>(`/contactList`,
                                                          {
                                                              queryParams: getQueryParams(pageSize,
                                                                                          pageNumber), skipLang: true
                                                          });
        const filteredUsers = (userDTOPage.content);
        return {
            ...userDTOPage,
            content: filteredUsers.map(userDTO => parseUserDTO(userDTO,
                                                               trmzFileConverter))
        };
    };

    const searchUsers = async (searchTerm: string,
                               pageSize: number,
                               pageNumber: number) => {
        const userDTOPage = await http.get<Page<UserDTO>>(`/contactList`,
                                                          {
                                                              queryParams: getQueryParams(pageSize,
                                                                                          pageNumber,
                                                                                          searchTerm), skipLang: true
                                                          });
        const filteredUsers = (userDTOPage.content);
        return {
            ...userDTOPage,
            content: filteredUsers.map(userDTO => parseUserDTO(userDTO,
                                                               trmzFileConverter))
        };
    };

    return {
        loadUsers,
        searchUsers
    };
};
